// The site being edited, with undo/redo. Each change is one step, except
// changes sharing a `group` key (dragging a colour picker, say), which merge
// into the step before them.
import { useCallback, useReducer } from "react";

const LIMIT = 60;

const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return { past: [], present: action.site, future: [], group: null };
    case "set": {
      const next = typeof action.update === "function" ? action.update(state.present) : action.update;
      if (next === state.present) return state;
      const merge = action.group && action.group === state.group;
      return {
        past: merge ? state.past : [...state.past, state.present].slice(-LIMIT),
        present: next,
        future: [],
        group: action.group || null,
      };
    }
    // The server's checked copy of what we already have: not a new step.
    case "replace":
      return { ...state, present: action.site };
    case "undo":
      if (!state.past.length) return state;
      return { past: state.past.slice(0, -1), present: state.past[state.past.length - 1], future: [state.present, ...state.future], group: null };
    case "redo":
      if (!state.future.length) return state;
      return { past: [...state.past, state.present], present: state.future[0], future: state.future.slice(1), group: null };
    default:
      return state;
  }
};

export const useSiteHistory = () => {
  const [state, dispatch] = useReducer(reducer, { past: [], present: null, future: [], group: null });
  return {
    site: state.present,
    canUndo: state.past.length > 0,
    canRedo: state.future.length > 0,
    reset: useCallback((site) => dispatch({ type: "reset", site }), []),
    update: useCallback((update, group) => dispatch({ type: "set", update, group }), []),
    replace: useCallback((site) => dispatch({ type: "replace", site }), []),
    undo: useCallback(() => dispatch({ type: "undo" }), []),
    redo: useCallback(() => dispatch({ type: "redo" }), []),
  };
};
